import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { SubMenuColumnContainer } from "./SubMenuColumn.styled";
const SubMenuColumn = (props) => {
    const { children, title } = props;
    return (_jsxs(SubMenuColumnContainer, { children: [!!title && _jsx(Typography, { variant: "body2", children: title }), children] }));
};
export { SubMenuColumn };
//# sourceMappingURL=SubMenuColumn.js.map